import { Pencil, Save, Trash2, X } from 'lucide-react';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import ModalWrapper from '../../../../../../Components/CustomModal/ModalWrapper';
import { getPrNo } from '../../../../../../Store/prosafe/proTransaction/PurOrder/getPrNo';
import { MultiSelect } from 'primereact/multiselect';
import { getPrNoItems } from '../../../../../../Store/prosafe/proTransaction/PurOrder/getPrNoItems';
import axios from 'axios';
import { V_URL } from '../../../../../../BaseUrl';
import { getViewPoItems } from '../../../../../../Store/prosafe/proTransaction/PurOrder/getViewPoItems';

const AutoPoModel = ({ modal, setItemsArr, itemsArr, form, data }) => {

  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(true);
  const [autoItemsData, setAutoItemsData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [selectedPr, setSelectedPr] = useState([]);

  useEffect(() => {
    if (form.party_id && form.project_id) {
      getPurRrqNo();
    }
  }, [form?.party_id, form.project_id]);

  useEffect(() => {
    if (form.party_id && form.project_id) {
      getRequestItems();
    }
  }, [selectedPr, form?.party_id, form?.project_id]);

  useEffect(() => {
    if (!modal.isShown) {
      setAutoItemsData([]);
      setOriginalData([]);
      setSelectedPr([]);
      // setIsEditing(false);
    }
  }, [modal.isShown]);

  const getRequestItems = () => {
    const formData = new URLSearchParams();
    formData.append("tag_number", 9);
    formData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"));
    formData.append("year_id", localStorage.getItem("PAY_USER_YEAR_ID"));
    formData.append("project_id", form.project_id);
    formData.append("party_id", form.party_id);
    formData.append("pr_no", JSON.stringify(selectedPr));
    dispatch(getPrNoItems({ formData }));
  }

  const getPurRrqNo = () => {
    const formData = new URLSearchParams();
    formData.append("tag_number", 9);
    formData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"));
    formData.append("year_id", localStorage.getItem("PAY_USER_YEAR_ID"));
    formData.append("project_id", form.project_id);
    formData.append("party_id", form.party_id);
    dispatch(getPrNo({ formData }));
  }

  const prNoData = useSelector((state) => state?.getPrNo?.user?.data);
  const prItemsData = useSelector((state) => state?.getPrNoItems?.user?.data);
  const partyData = useSelector((state) => state.getParty?.user?.data) || [];

  const calculateAmounts = (qty, rate, gst, discount) => {
    const amount = (qty || 0) * (rate || 0);
    const discount_amount = (amount * (discount || 0)) / 100;
    const taxable_amount = amount - discount_amount;
    const gst_amount = (taxable_amount * (gst || 0)) / 100;
    const total_amount = taxable_amount + gst_amount;
    return { amount, discount_amount, taxable_amount, gst_amount, total_amount };
  };

  const calculatePendingQuantity = (prItem) => {
    const matchingItems = itemsArr?.filter(item =>
      item.from_id === prItem?.from_id &&
      item.detail_id === prItem?.detail_id &&
      item.item_id === prItem?.item_data?._id
    );
    // Calculate total quantity already added
    const totalAdded = matchingItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
    // Return remaining quantity (original quantity - already added)
    return (prItem.quantity || 0) - totalAdded;
  };

  useEffect(() => {
    if (Array.isArray(prItemsData)) {
      const mappedItems = prItemsData?.filter(e => {
        const pendingQty = calculatePendingQuantity(e);
        return pendingQty > 0 || !itemsArr?.some(item =>
          item.from_id === e?.from_id &&
          item.detail_id === e?.detail_id &&
          item.item_id === e?.item_data?._id
        );
      })?.map((e) => {
        const pendingQty = calculatePendingQuantity(e);
        const qty = e.quantity || 0;
        const rate = e.rate || 0;
        const gst = e.gst || 0;
        const discount = e.discount || 0;
        const { amount, discount_amount, taxable_amount, gst_amount, total_amount } = calculateAmounts(pendingQty, rate, gst, discount);
        return {
          from_id: e?.from_id,
          detail_id: e?.detail_id,
          item_id: e?.item_data?._id,
          item: e.item_data?.name || '',
          item_no: e.item_no,
          // item_length: e.item_length || "",
          // item_width: e.item_width || "",
          item_weight: e.item_weight || "",
          // item_radius: e.item_radius || "",
          // item_thickness: e.item_thickness || "",
          // assembly_weight: e.assembly_weight || "",
          // assembly_surface_area: e.assembly_surface_area || "",
          original_qty: e.quantity || 0,
          pending_qty: pendingQty,
          require_qty: pendingQty,
          quantity: pendingQty,
          rate,
          amount,
          discount,
          discount_amount,
          taxable_amount,
          gst,
          gst_amount,
          total_amount,
          remarks: e.remarks || '',
          mrp: '',
          isAuto: true
        };
      });
      setAutoItemsData(mappedItems);
      setOriginalData(mappedItems);
    }
  }, [prItemsData, itemsArr]);

  const handleSubmit = async () => {
    const hasInvalid = autoItemsData?.some((item) => {
      return (
        !item.require_qty || item.require_qty <= 0 ||
        !item.rate || item.rate <= 0
      );
    });

    if (hasInvalid) {
      toast.error("Please fill all required fields: PO Qty, Rate for each item.");
      return;
    }
    const updatedItems = autoItemsData?.map((e) => ({
      ...e,
      original_qty: e?.quantity,
      quantity: e.require_qty,
      required_qty: 0,
      discount: e?.discount,
      discount_amount: e?.discount_amount?.toFixed(2),
      taxable_amount: e?.taxable_amount?.toFixed(2),
    }));

    if (data?._id) {
      const payload = {
        id: data._id,
        items_details: JSON.stringify(updatedItems),
      };
      const resp = await axios.post(`${V_URL}/prosafe/pro-add-po-item`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('PAY_USER_TOKEN')}` },
      });
      if (resp.data.success) {
        toast.success(resp.data.message);
        dispatch(getViewPoItems({ formData: { id: data._id } }));
        modal.hide();
      } else {
        toast.error(resp.data.message);
      }
    } else {
      setItemsArr(prev => [...prev, ...updatedItems]);
    }
    modal.hide();
    toast.success('Items added successfully');
  }

  const getPartyName = (partyId) => {
    const party = partyData.find(party => party._id === partyId);
    return party ? party.name : 'N/A';
  };

  return (
    <ModalWrapper
      title="Auto Items Details"
      isShown={modal.isShown}
      hide={modal.hide}
      footer={false}
      customSize={"modal-90w"}
    >
      <>
        <div className='row'>
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms custom-select-wpr">
              <label>PR No. <span className="login-danger">*</span></label>
              <MultiSelect
                value={selectedPr}
                options={prNoData?.map(e => ({ label: e.voucher_no, value: e.voucher_no }))}
                onChange={(e) => {
                  setSelectedPr(e.value);
                }}
                placeholder="Select PR No."
                className="w-100"
              />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className="table-responsive">
            <table className="table border-0 custom-table comman-table mb-0">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th>Party</th>
                  <th>Item Name</th>
                  <th>Item No</th>
                  {/* <th>Length</th>
                  <th>Width</th> */}
                  {/* <th>Weight</th> */}
                  {/* <th>Radius</th>
                  <th>Thickness</th>
                  <th>Assembly Weight</th>
                  <th>Surface Area</th> */}
                  <th>PR Qty</th>
                  <th>Available Qty</th>
                  <th>PO Qty</th>
                  <th>Original Rate(₹)</th>
                  <th>Purchase Rate(₹)</th>
                  <th>Amount(₹)</th>
                  <th>Discount(%)</th>
                  <th>Discount Amount(₹)</th>
                  <th>Taxable Amount(₹)</th>
                  <th>GST(%)</th>
                  <th>GST Amount(₹)</th>
                  <th>Total Amount(₹)</th>
                  <th>Remarks</th>
                  <th className='text-end'>Action</th>
                </tr>
              </thead>
              <tbody>
                {autoItemsData?.map((elem, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{getPartyName(form.party_id)}</td>
                    <td>{elem.item}</td>
                    <td>{elem.item_no || "-"}</td>
                    {/* <td>{elem.item_length || "-"}</td>
                    <td>{elem.item_width || "-"}</td> */}
                    {/* <td>{elem.item_weight || "-"}</td> */}
                    {/* <td>{elem.item_radius || "-"}</td>
                    <td>{elem.item_thickness || "-"}</td>
                    <td>{elem.assembly_weight || "-"}</td>
                    <td>{elem.assembly_surface_area || "-"}</td> */}
                    <td>{elem.original_qty || 0}</td>
                    <td>{elem.pending_qty || 0}</td>
                    <td>
                      {isEditing ? (
                        <input
                          type="number"
                          style={{ width: "110px" }}
                          className="form-control"
                          value={elem.require_qty || ''}
                          onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].require_qty = parseFloat(e.target.value) || 0;
                            const amounts = calculateAmounts(updated[i].require_qty, updated[i].rate, updated[i].gst, updated[i].discount);
                            Object.assign(updated[i], amounts);
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.require_qty}
                    </td>
                    <td>
                      {isEditing ? (
                        <input
                          type="text"
                          style={{ width: "110px" }}
                          className="form-control"
                          value={elem.mrp || ''}
                          onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].mrp = e.target.value;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.mrp || "-"}
                    </td>
                    <td>
                      {isEditing ? (
                        <input
                          type="number"
                          className="form-control"
                          style={{ width: "110px" }}
                          value={elem.rate || ''}
                          onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].rate = parseFloat(e.target.value) || 0;
                            const amounts = calculateAmounts(updated[i].require_qty, updated[i].rate, updated[i].gst, updated[i].discount);
                            Object.assign(updated[i], amounts);
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.rate}
                    </td>
                    <td>{elem.amount?.toFixed(2)}</td>
                    <td>
                      {isEditing ? (
                        <input
                          type="number"
                          style={{ width: "110px" }}
                          className="form-control"
                          value={elem.discount || ''}
                          onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].discount = parseFloat(e.target.value) || 0;

                            const amounts = calculateAmounts(
                              updated[i].require_qty,
                              updated[i].rate,
                              updated[i].gst,
                              updated[i].discount
                            );

                            Object.assign(updated[i], amounts);
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.discount}
                    </td>
                    <td>{elem.discount_amount?.toFixed(2)}</td>
                    <td>{elem.taxable_amount?.toFixed(2)}</td>
                    <td>
                      {isEditing ? (
                        <input
                          type="number"
                          style={{ width: "110px" }}
                          className="form-control"
                          value={elem.gst || ''}
                          onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].gst = parseFloat(e.target.value) || 0;
                            const amounts = calculateAmounts(updated[i].require_qty, updated[i].rate, updated[i].gst, updated[i].discount);
                            Object.assign(updated[i], amounts);
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.gst}
                    </td>
                    <td>{elem.gst_amount?.toFixed(2)}</td>
                    <td>{elem.total_amount?.toFixed(2)}</td>
                    <td>
                      {isEditing ? (
                        <input
                          type="text"
                          style={{ width: "110px" }}
                          className="form-control"
                          value={elem.remarks || ''}
                          onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].remarks = e.target.value;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.remarks || "-"}
                    </td>
                    <td className="d-flex justify-content-end">
                      <a
                        // type="button"
                        className="action-icon p-1 mx-1"
                        onClick={() => {
                          const filtered = autoItemsData.filter((_, index) => index !== i);
                          setAutoItemsData(filtered);
                        }}
                      >
                        <Trash2 />
                      </a>
                    </td>
                  </tr>
                ))}
                {autoItemsData?.length === 0 ? (
                  <tr>
                    <td colSpan="999">
                      <div className="no-table-data">
                        No Data Found!
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
          <div className="mt-3 text-end">
            {/* {isEditing ? (
              <>
                <button className="btn btn-success mx-2" onClick={() => setIsEditing(false)}>
                  <Save className="me-1" /> Save
                </button>
                <button className="btn btn-secondary mx-2" onClick={() => {
                  setAutoItemsData([...originalData]);
                  setIsEditing(false);
                }}>
                  <X className="me-1" /> Cancel
                </button>
              </>
            ) : (
              <button className="btn btn-outline-primary mx-2" onClick={() => setIsEditing(true)}>
                <Pencil className="me-1" /> Edit All
              </button>
            )} */}
            <button className="btn btn-secondary mx-2" onClick={() => {
              setAutoItemsData([...originalData])
              modal.hide()
            }}>
              <X className="me-1" /> Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </>
    </ModalWrapper >
  )
}

export default AutoPoModel